module.exports = __webpack_public_path__ + "static/media/HB-JBC_Bombardier_BD-500-1A10_CS100_BCS1_-_SWR_(33142509796).430191f1.jpg";